import { Modal, Cell, Banner } from '@telegram-apps/telegram-ui';
import { Villa, STATUS_LABELS } from '../types';
import { updateVilla } from '../api';

interface StatusPickerProps {
  villa: Villa;
  open: boolean;
  onClose: () => void;
  onChange: (newStatus: string) => void;
}

const STATUSES: Exclude<Villa['status'], 'archived'>[] = ['new', 'contacted', 'visited', 'shortlisted'];

const STATUS_EMOJIS: Record<Exclude<Villa['status'], 'archived'>, string> = {
  new: '🆕',
  contacted: '✉️',
  visited: '👁️',
  shortlisted: '⭐',
};

const STATUS_DESCRIPTIONS: Record<Exclude<Villa['status'], 'archived'>, string> = {
  new: 'Только добавлена',
  contacted: 'Написали владельцу',
  visited: 'Посмотрели вживую',
  shortlisted: 'В финальном списке',
};

export default function StatusPicker({
  villa,
  open,
  onClose,
  onChange,
}: StatusPickerProps) {
  const handleStatusSelect = async (status: string) => {
    try {
      await updateVilla(villa.id, { status });
      onChange(status);
      onClose();
    } catch (err) {
      console.error('Failed to update status:', err);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      header="Выберите статус"
    >
      <div className="status-picker">
        <Banner
          header={villa.title || new URL(villa.url).hostname}
          subheader={`${STATUS_EMOJIS[villa.status as Villa['status']]} ${STATUS_LABELS[villa.status]}`}
          type="generic"
        />

        <div className="status-picker__list">
          {STATUSES.map(status => (
            <Cell
              key={status}
              onClick={() => handleStatusSelect(status)}
              subtitle={STATUS_DESCRIPTIONS[status]}
              after={STATUS_EMOJIS[status]}
              multiline={false}
            >
              {STATUS_LABELS[status]}
            </Cell>
          ))}
        </div>
      </div>
    </Modal>
  );
}
